

<div class="relative overflow-x-auto">
  <div *ngIf="appels == undefined || appels == null" > 
    <p class="w-full text-2xl text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
      Vous ne suivez actuellement aucun cours, consulter la liste de nos <a [routerLink]="['/dashboard/appels']" class="text-blue-600" >certificats</a>  disponibles et postulez.
    </p>
  </div>
  <table *ngIf=" appels != undefined &&  appels.length >0" class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
      <thead class="text-sm text-white  bg-green-500 dark:bg-gray-700 dark:text-gray-400">
          <tr>
              <th scope="col" class="px-6 py-3">
                  Nom Certificat
              </th>
              <th scope="col" class="px-6 py-3">
                  Date début
              </th>
              <th scope="col" class="px-6 py-3">
                  Date fin
              </th>
              <th scope="col" class="px-6 py-3">
                 Terminé
              </th>
              <!-- <th scope="col" class="px-6 py-3">
                Gérer
             </th> -->
          </tr>
      </thead>
      <tbody  >
          <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700" *ngFor="let item of appels">
              <th  scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                  <a href={{item.courseimage}} >{{item.fullname}}</a> 
              </th>
              <td class="px-6 py-4">
                {{item.startdate *1000 | date : " le d MMMM yyyy" }}
              </td>
              <td *ngIf="item.enddate === 0" class="px-6 py-4">
                
                ----
              </td>
              <td *ngIf="item.enddate != 0" class="px-6 py-4">
                
                {{item.enddate*1000 | date : " le d MMMM yyyy" }}
              </td>
              <td class="px-6 py-4">

                <div class="sm rounded-lg p-1 text-white w-24 text-center"
                [style.backgroundColor]="item.completed == 'true' ? '#28b45b' : (item.etat == 'false' ? '#1d71b8' : '#f04438')"
                >

                  {{ item.completed  == 'true' ? 'Oui' : 'Non' }}
                </div>

              </td>
              <!-- <td class="px-6 py-4">
                <div (click)="onClick()" class="cursor-pointer">
                  <svg class="w-4 h-4 text-gray-600 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 4 15">
                    <path d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/>
                  </svg>
                </div>

              </td> -->
          </tr>
      </tbody>
      
  </table>
  
</div>

